module.exports = __webpack_public_path__ + "static/media/How to Use.f3d47dcb.webp";